// Note: this component generates a random id allowing other components to
// form relationships with that id using provide and inject and emiting
// events to each other
function maybeMsCrypto() {
  const { crypto, msCrypto } = window
  // msCyrpto is a fallback method
  // for IE 11 compatibility
  return crypto || msCrypto
}
function getsRandomValues() {
  const unitArray = new Uint32Array(1)
  const cryptoObject = maybeMsCrypto()
  return cryptoObject.getRandomValues(unitArray)
}

export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    dispatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const [randomValues] = getsRandomValues()
    return {
      randomValues,
      // you could also just use
      // eslint-disable-next-line no-underscore-dangle
      // randomValues: this._uid
      // to generate a random id
      // vue suggests this is a fragile solution
      // as _uid is reserved for interal use only
      // making the api subject to change but. You can
      // read more about it below.
      // https://github.com/vuejs/vue/issues/5886#issuecomment-308647738
    }
  },
  render(h) {
    return h(this.tag, this.$scopedSlots.default({ randomId: this.randomValues }))
  },
}



// WEBPACK FOOTER //
// ./src/components/RandomId.js